import React, { useState, useEffect } from "react";
import GridTable from "@nadavshaar/react-grid-table";
import setColumnsSub from "./setColumnsSub.js";
import Modalv2 from "../../components/tables/Modalv2.js";
import ValidView from "../../components/app/validView.js";
import Spinner from "react-bootstrap/Spinner";
import ModalMultiLogs from "./ModalMultiLogs.js";
import ModalExportExcel from "../../components/tables/ModalExportExcel.js";
import CustomHeader from "../../components/tables/CustomHeader.js";
import { searchUtils } from "../../components/tables/searchUtils.js";

const Subscriptions = () => {
  const rowsPerPageString = process.env.REACT_APP_GRID_ROWSPERPAGE;
  const rowsPerPageArray = rowsPerPageString.split(',').map(Number);

  const [resetGridTable, setResetGridTable] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [rowsLoading, setRowsLoading] = useState(false);
  const [columnsGrid, setColumnsGrid] = useState([]);
  const [show, setShow] = useState(false);
  const [show_sc, setshow_sc] = useState(false);
  const [show_excel, setshow_excel] = useState(false);
  const [selectedRowsIds, setSelectedRowsIds] = useState([]);

  const handleClose = () => setShow(false);
  const handleClose_sc = () => setshow_sc(false);
  const handleClose_excel = () => setshow_excel(false);

  const [objFilter, setObjFilter] = useState([]);
  const [stringFilter, setStringFilter] = useState(null);
  const { allowWrite, allowView, userToken } = ValidView("Logs");

  const nameView = "Log";
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(rowsPerPageArray[0]);
  const [dataItem, setItem] = useState({
    codeItem: 0,
    typeView: "",
    nameView: "",
  });


  const handleReloadComponent = () => {
    setPage(1);
    setResetGridTable(!resetGridTable);
  };

  useEffect(() => {
    if (allowView) {
      setColumnsGrid(setColumnsSub({ modalDetail, allowWrite, changeDelay }));
      setRowsLoading(true);
    }
  }, [allowView, allowWrite]);

  const modalDetail = (codeItem, typeView) => {
    setShow(true);
    setItem({ codeItem, typeView, nameView });
  };

  const modal_sc = (codeItem, typeView) => {
    setshow_sc(true);
  };

  const modal_excel = () => {
    setshow_excel(true);
  };

  const changeDelay = (textSearch, tableManager, column) => {
    const { searchApi } = tableManager;
    const { searchText, setSearchText } = searchApi;
    const setSearchAndFilter = (searchText, stringFilter) => {
      setSearchText(searchText);
      setStringFilter(stringFilter);
    };
    searchUtils(textSearch, setSearchAndFilter, column, searchText, objFilter);
  };

  const onRowsRequest = async (requestData, tableManager) => {
    setLoading(true);
    
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userToken
      }
    };

    const response = await fetch(process.env.REACT_APP_NERTHUS_API_URL + '/users/returnLogs/subscriptions?page=' + (page) + '&perPage=' + pageSize + requestData.searchText, requestOptions)
    .then((response) => {
      setLoading(false);
      return response.json();
    }).catch(console.warn);
    
  if (!response?.data) return;

    return {
      rows: response.data,
      totalRows: response.total_count,
    };
  };

  const OnPageChange = (event) => {
    setPage(event);
  }

  let dataSendLogs = { 'typeView': 'Edit', 'codeItem': selectedRowsIds, 'nameView': 'Send Logs' };
  const urlBaseExport = '/users/returnLogs/exportToExcel?page=1&perPage=9999';

  return (
    <>
      <div className="tableWrapper">
        {!rowsLoading
          ? (<Spinner animation="border" role="status" variant="secondary" >
            <span className="visually-hidden">Loading...</span>
          </Spinner>) : (<>
            <GridTable
              key={resetGridTable}
              columns={columnsGrid}
              rowIdField={'code'}
              onRowsRequest={onRowsRequest}
              isLoading={isLoading}
              pageSizes={rowsPerPageArray}
              pageSize={pageSize}
              onPageSizeChange={setPageSize}
              onPageChange={OnPageChange}
              selectedRowsIds={selectedRowsIds}
              onSelectedRowsChange={setSelectedRowsIds}
              showSearch={false}
              showColumnVisibilityManager={false}
              highlightSearch={false}
              minSearchChars={3}
              components={{ Header: (props) => <CustomHeader {...props} selectedRowsIds={selectedRowsIds} allowWrite={allowWrite} modal_excel={modal_excel} modal_sc={modal_sc} setStringFilter={setStringFilter}/>  }}
            />
          </>)}
      </div>
      <Modalv2 show={show} handleClose={handleClose} dataItem={dataItem} setRenderRows={handleReloadComponent} />
      <ModalMultiLogs show={show_sc} handleClose={handleClose_sc} dataItem={dataSendLogs} setRenderRows={[]} />
      <ModalExportExcel show={show_excel} handleClose={handleClose_excel} objTextFind={stringFilter} urlBaseExport={urlBaseExport} nameFile={'Logs.xlsx'} />
    </>
  );
};

export default Subscriptions;